import { RightArrowIcon, TickMarkIcon } from '@sketchnote/icons';
import { ContainerFixedMargin, Switch } from '@sketchnote/shared-components';
import Link from 'next/link';
import React from 'react';
import Sticky from 'react-stickynode';
const { useState } = React;
import { Footer, FooterSecondary, Header } from '../../components';

//Older Pricing UI
export const Pricing = (): JSX.Element => {
  const [toggle, setToggle] = useState(false);

  return (
    <div>
      <Header />
      <div className="bg-gray-199">
        <div className="bigScreen:max-w-1500 bigScreen:mx-auto flex relative mobile:h-460 tablet:h-415 laptop:h-384 bigScreen:h-auto bigScreen:flex-row laptop:flex-col tablet:flex-col mobile:flex-col justify-between  ">
          <div className="flex">
            <span
              style={{ lineHeight: '100%' }}
              className=" pr-24 text-blue-700 mb-36 bigScreen:text-7xl mobile:text-6xl font-bold laptop:pl-70 desktop:pl-96 laptop:pt-160 tablet:pl-64 mobile:pt-90 mobile:pl-24 bigScreen:pt-128 bigScreen:pl-135"
            >
              Choose the{' '}
              <span className="text-blue-500 tablet:pr-280 laptop:pr-0">perfect plan!</span>
            </span>
          </div>
          {/* <img
          src="https://res.cloudinary.com/samvibes/image/upload/landing/Pricing/hero-mobile.png"
          alt="Lucy Lee writing on a notepad"
          className="self-end z-10 desktop:hidden laptop:hidden tablet:inline-block contain overflow-hidden tablet:max-h-500 mobile:overflow-hidden mobile:-mt-64 laptop:-mt-10 truncate"
        /> */}
          <div className="">
            <img
              src="https://res.cloudinary.com/samvibes/image/upload/landing/Pricing/hero.png"
              alt="Lucy Lee writing on a notepad"
              className="z-20 absolute bigScreenTwo:top-86 bigScreen:top-89 bigScreen:right-170 h-256 mobile:right-24 laptop:right-45 desktop:right-75 mobile:bottom-35"
            />
            <img
              src="https://res.cloudinary.com/samvibes/image/upload/landing/pricing_yellow.png"
              alt="yellow background"
              className="self-end z-10 max-h-435  mobile:hidden  bigScreen:inline-block bigScreenTwo:hidden truncate desktop:max-h-420"
            />
            <img
              src="https://res.cloudinary.com/samvibes/image/upload/v1627554480/landing/pricing_yellow_two.png"
              alt="yellow background"
              className="self-end absolute z-10 mobile:h-314 tablet:h-280 laptop:h-415 bottom-0 right-0 mobile:inline-block bigScreen:hidden"
            />
            <img
              src="https://res.cloudinary.com/samvibes/image/upload/v1627562276/landing/yellow-whole.png"
              alt="yellow background"
              className="self-end z-10  max-h-415 right-0  mobile:hidden bigScreenTwo:inline-block"
            />
          </div>
        </div>
      </div>
      <div className="bg-gray-199 bigScreen:-mt-144">
        <ContainerFixedMargin>
          <div className="z-30 bigScreen:pb-34 laptop:pb-90 mobile:pb-128  w-full">
            <div className="mobile:mx-auto flex bigScreen:flex-row desktop:flex-col laptop:flex-col tablet:flex-col mobile:flex-col ">
              <div
                style={{ borderRadius: '12px' }}
                // className="bigScreen:mr-32 mx-auto relative p-32 z-10 mobile:mb-32  bigScreen:w-364 mobile:w-full bg-white rounded-xl border shadow-lg mobile:h-540 desktop:h-500 desktop:mt-32">
                className="bigScreen:mr-32 p-32 relative z-10 mobile:-mt-72 bigScreen:mt-32 mobile:mb-32   bigScreen:w-364 mobile:w-full bg-white  border shadow-lg mobile:h-540 desktop:h-500"
              >
                <div className="relative h-full">
                  <p className="text-4xl text-blue-700 font-semibold">
                    Basic <span className="text-blue-500">Free</span>
                  </p>
                  <p className="text-sm text-gray-600">Learn and create along with Sketchnote</p>
                  <p className="text-sm text-gray-500 pb-32 border-b">Monthly per user</p>
                  <p className="text-xs text-gray-500 pt-32 mb-16">Includes</p>
                  <p className="mb-8 text-gray-300">
                    <TickMarkIcon />
                    &nbsp;&nbsp;
                    <span className="text-blue-800 text-lg ">&nbsp;1 member</span>
                  </p>
                  <p className="mb-8 text-gray-300">
                    <TickMarkIcon />
                    &nbsp;&nbsp;
                    <span className="text-blue-800 text-lg">&nbsp;No workspace</span>
                  </p>
                  <p className="mb-8 text-gray-300">
                    <TickMarkIcon />
                    &nbsp;&nbsp;
                    <span className="text-blue-800 text-lg">&nbsp;1 creation version</span>
                  </p>
                  <p className="mb-8 text-gray-300">
                    <TickMarkIcon />
                    &nbsp;&nbsp;
                    <span className="text-blue-800 text-lg">&nbsp;Limited guest additions</span>
                  </p>
                  <p className="mb-8 text-gray-300">
                    <TickMarkIcon />
                    &nbsp;&nbsp;
                    <span className="text-blue-800 text-lg ">&nbsp;Limited file uploads</span>
                  </p>

                  <Link href={'/signup'}>
                    <a className="bg-white absolute  align-bottom mobile:bottom-0  text-blue-500 border border-blue-500 rounded py-8 font-medium  mobile:w-full tablet:w-304 bigScreen:w-full text-center">
                      Sign up for free
                    </a>
                  </Link>
                </div>
              </div>

              <div
                style={{ borderRadius: '12px' }}
                className="mx-auto p-32 z-10 mobile:mb-32 desktop:mr-32 bigScreen:w-364 mobile:w-full   bg-white rounded-xl border shadow-lg mobile:h-630  tablet:h-540 desktop:h-575"
              >
                <div className="relative h-full">
                  <p className="relative flex bigScreen:flex-row desktop:flex-col laptop:flex-row tablet:flex-row mobile:flex-col-reverse">
                    <p className="text-4xl text-blue-700 font-semibold">Pro&nbsp;</p>
                    <span className=" max-w-200 block ">
                      <span className="inline-block text-sm text-blue-700 font-medium">
                        For beta phase&nbsp;&nbsp;
                      </span>
                      {toggle ? (
                        <span className="text-4xl text-primary-400 font-semibold line-through">
                          $12
                        </span>
                      ) : (
                        <span className="text-4xl text-primary-400 font-semibold line-through">
                          $10
                        </span>
                      )}
                      <img
                        src="https://res.cloudinary.com/samvibes/image/upload/landing/Pricing/Free.png"
                        alt="free"
                        className="w-48  absolute mobile:-top-15 bigScreen:-top-15 bigScreen:left-210 mobile:left-165 tablet:left-225 desktop:top-35 desktop:left-170"
                      />
                    </span>
                  </p>
                  <p className="text-sm text-gray-600">
                    Get more out of your Sketchnote experience
                  </p>
                  <p className="text-sm text-gray-500 pb-32 border-b">Monthly per user</p>
                  <p className="text-xs text-gray-500 pt-32 mb-16">All basic plan features, plus</p>
                  <p className="mb-8 text-gray-300">
                    <TickMarkIcon />
                    &nbsp;&nbsp;
                    <span className="text-blue-800 text-lg">&nbsp;1 member</span>
                  </p>
                  <p className="mb-8 text-gray-300">
                    <TickMarkIcon />
                    &nbsp;&nbsp;
                    <span className="text-blue-800 text-lg">&nbsp;1 workspace</span>
                  </p>
                  <p className="mb-8 text-gray-300">
                    <TickMarkIcon />
                    &nbsp;&nbsp;
                    <span className="text-blue-800 text-lg">&nbsp;Unlimited creation versions</span>
                  </p>
                  <p className="mb-8 text-gray-300">
                    <TickMarkIcon />
                    &nbsp;&nbsp;
                    <span className="text-blue-800 text-lg">&nbsp;Unlimited guest additions</span>
                  </p>
                  <p className="tablet:mb-48 mobile:mb-24 text-gray-300">
                    <TickMarkIcon />
                    &nbsp;&nbsp;
                    <span className="text-blue-800 text-lg ">&nbsp;1 GB file upload capacity</span>
                  </p>

                  <Link href={'/signup'}>
                    <a className="bg-blue-500 absolute mobile:bottom-0  align-bottom text-white border border-blue-500 rounded py-8 font-medium mobile:w-full tablet:w-304 bigScreen:w-full text-center flex-grow">
                      Sign up for free
                    </a>
                  </Link>
                </div>
              </div>

              <div
                style={{ borderRadius: '12px' }}
                className="mx-auto relative p-32 z-10 mobile:mb-32  bigScreen:w-364 mobile:w-full bg-white rounded-xl border shadow-lg mobile:h-540 desktop:h-500 desktop:mt-32"
              >
                <div className="relative h-full">
                  <p className="flex bigScreen:flex-row desktop:flex-col laptop:flex-row tablet:flex-row mobile:flex-col-reverse">
                    <p className="text-4xl text-blue-700 font-semibold">Team&nbsp;</p>
                    <span className="relative max-w-200 block">
                      <span className="inline-block text-sm text-blue-700 font-medium">
                        For beta phase&nbsp;&nbsp;
                      </span>
                      {toggle ? (
                        <span className="text-4xl text-primary-400 font-semibold line-through">
                          $15
                        </span>
                      ) : (
                        <span className="text-4xl text-primary-400 font-semibold line-through">
                          $12
                        </span>
                      )}
                      <img
                        src="https://res.cloudinary.com/samvibes/image/upload/landing/Pricing/Free.png"
                        alt="free"
                        className="w-48  absolute -top-15 bigScreen:-right-30 desktop:-right-15 mobile:-right-10 tablet:-right-50"
                      />
                    </span>
                  </p>

                  <p className="text-sm text-gray-600">Collaborate with your team and guests</p>
                  <p className="text-sm text-gray-500 pb-32 border-b">Monthly per user</p>
                  <p className="text-xs text-gray-500 pt-32 mb-16">All pro plan features, plus</p>
                  <div className="">
                    <div>
                      <p className="mb-8 text-gray-300">
                        <TickMarkIcon />
                        &nbsp;&nbsp;
                        <span className="text-blue-800 text-lg ">&nbsp;Multiple workspaces</span>
                      </p>
                      <p className="mb-8 text-gray-300">
                        <TickMarkIcon />
                        &nbsp;&nbsp;
                        <span className="text-blue-800 text-lg">
                          &nbsp;5 GB file upload capacity
                        </span>
                      </p>
                      <p className=" text-gray-300">
                        <TickMarkIcon />
                        &nbsp;&nbsp;
                        <span className="text-blue-800 text-lg">
                          &nbsp;5 GB file upload capacity
                        </span>
                      </p>
                    </div>
                    <Link href={'/signup'}>
                      <a className=" absolute bottom-0 align-bottom bg-white text-blue-500 border border-blue-500 rounded py-8 font-medium mobile:w-full tablet:w-304 bigScreen:w-full text-center">
                        Sign up for free
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="mx-auto justify-around flex text-gray-600 text-sm">
              <span className="block">
                <span className="inline-block -mt-2">Pay annually</span>
                <span className="inline-block pt-16 mx-8">
                  <Switch sliderClassName="h-16 pt-8 mt-4" onChange={() => setToggle(!toggle)} />
                </span>
                <span className="inline-block -mt-2">Pay monthly</span>
              </span>
            </div>
          </div>
        </ContainerFixedMargin>
      </div>
      <img
        src="https://res.cloudinary.com/samvibes/image/upload/landing/Pricing/grey-curve.png"
        alt="grey curve"
        className="z-10 w-full mb-90"
      />
      <div className="bigScreen:max-w-1400 bigScreen:mx-auto">
        <img
          src="https://res.cloudinary.com/samvibes/image/upload/landing/Pricing/pricing-swiss-knife.png"
          alt="An opened up Swiss army knife"
          className="z-20 max-h-248 desktop:-mt-256 mobile:-mt-209"
        />
      </div>

      <ContainerFixedMargin className="mobile:hidden bigScreen:block w-full">
        <table className="w-864 table-fixed border-collapse table mx-auto">
          <th className="font-bold text-blue-800 mb-32 text-2xl block w-332 text-left">
            <span className="text-blue-500">Compare </span>plans and features
          </th>
        </table>
      </ContainerFixedMargin>
      <Sticky
        enabled={true}
        top={60}
        bottomBoundary={'#security'}
        innerZ={11}
        className="mobile:hidden bigScreen:block mb-64 bg-white"
      >
        <div
          style={{ borderRadius: '12px', boxShadow: '0px 2px 12px rgba(19, 23, 32, 0.08)' }}
          className="fixed bg-white  h-120 rounded-lg w-full flex"
        >
          <ContainerFixedMargin className="w-full py-20 table-row-group">
            <table className="w-864 table-fixed border-collapse table mx-auto">
              <tbody className="table-row-group">
                <tr className="table-row ">
                  <td className="w-256 table-cell align-top  text-blue-800 font-medium"></td>
                  <td className="table-cell align-top text-blue-800 font-medium">
                    <span className="block font-bold text-3xl text-blue-800 mb-8">Basic</span>

                    <Link href={'/signup'}>
                      <a className="w-120 bg-white border border-blue-500 text-blue-500 py-4 px-8 rounded-sm text-sm text-center">
                        Sign up for free
                      </a>
                    </Link>
                  </td>
                  <td className="table-cell align-top  text-blue-800 font-medium">
                    <span className="block font-bold text-3xl text-blue-800 mb-8">Pro</span>

                    <Link href={'/signup'}>
                      <a className="w-120 bg-blue-500 border border-blue-500 text-white py-4 px-8 rounded-sm text-sm text-center">
                        Sign up for free
                      </a>
                    </Link>
                  </td>
                  <td className="table-cell align-top  text-blue-800 font-medium">
                    <span className="block font-bold text-3xl text-blue-800 mb-8">Team</span>
                    <Link href={'/signup'}>
                      <a className="w-120 bg-white border border-blue-500 text-blue-500 py-4 px-8 rounded-sm text-sm text-center">
                        Sign up for free
                      </a>
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </ContainerFixedMargin>
        </div>
      </Sticky>

      <ContainerFixedMargin className="desktop:pt-40 desktop:pb-48 laptop:pb-48 mobile:pb-64 tablet:pb-64">
        <div className="laptop:hidden  mobile:hidden tablet:hidden bigScreen:block">
          <table className="w-864 table-fixed border-collapse table mx-auto">
            <tbody className="table-row-group">
              <tr className="table-row">
                <td className="border-b w-256 table-cell align-top pt-64 pb-12 text-blue-800 font-medium">
                  Usage
                </td>
                <td className="border-b table-cell pb-12 text-gray-500 font-medium text-sm"></td>
                <td className="border-b table-cell pb-12 text-gray-500 font-medium text-sm"></td>
                <td className="border-b table-cell pb-12 text-gray-500 font-medium text-sm"></td>
              </tr>

              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg">Members</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">1 member</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">1 member</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">Unlimited</td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg">Guests</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">5 Guests</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">Unlimited</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">Unlimited</td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg">Workspaces</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  1 Default workspace
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  1 Default workspace
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">Unlimited</td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg">
                  Full version history
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg">File uploads</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">1 GB</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">5 GB</td>
              </tr>
              <tr className="table-row">
                <td className="table-cell py-12 text-gray-500 text-lg">Docs export</td>
                <td className="table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b w-256 pr-24 table-cell align-top pt-48 pb-12 text-blue-800 font-medium">
                  Collaboration
                </td>
                <td className="border-b table-cell pt-48 pb-12 text-gray-500 font-medium text-sm"></td>
                <td className="border-b table-cell pt-48 pb-12 text-gray-500 font-medium text-sm"></td>
                <td className="border-b table-cell pt-48 pb-12 text-gray-500 font-medium text-sm"></td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg">Workspaces</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg">Boards</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg">Creations</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg">Docs</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg">Kanban</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg"> Link sharing</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="table-cell py-12 text-gray-500 text-lg"></td>
                <td className="table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="table-cell py-12 text-blue-800 text-xss">
                  *Collaboration for pro members only alongside other pro members
                </td>
                <td className="table-cell py-12 text-blue-800 text-lg"></td>
              </tr>

              <tr className="table-row">
                <td className="border-b w-256 pr-24 table-cell align-top pt-48 pb-12 text-blue-800 font-medium">
                  Features
                </td>
                <td className="border-b table-cell pt-48 pb-12 text-gray-500 font-medium text-sm"></td>
                <td className="border-b table-cell pt-48 pb-12 text-gray-500 font-medium text-sm"></td>
                <td className="border-b table-cell pt-48 pb-12 text-gray-500 font-medium text-sm"></td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg pr-64">
                  Mobile app
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg pr-64">
                  Autofill legal templates
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg  pr-64">
                  Kanban and calendar views for boards
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg  pr-64">
                  Commenting feature: Learn, creation, and docs
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg  pr-64">
                  Kanban and calendar views for creations
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg  pr-64">
                  Desktop app
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg pr-64">
                  10+ block content types
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg  pr-64">
                  Restore tasks
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg  pr-64">
                  Highlighting feature: Learn, creation, and docs
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg  pr-64">
                  Search: Lessons, creations, docs, boards, comments, users
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg pr-64">Reminders</td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg pr-64">
                  Notifications
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="table-cell py-12 text-gray-500 text-lg  pr-64">
                  Audio in learn cards
                </td>
                <td className="table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b w-256 pr-24 table-cell align-top pt-48 pb-12 text-blue-800 font-medium">
                  Storage
                </td>
                <td className="border-b table-cell pt-48 pb-12 text-gray-500 font-medium text-sm"></td>
                <td className="border-b table-cell pt-48 pb-12 text-gray-500 font-medium text-sm"></td>
                <td className="border-b table-cell pt-48 pb-12 text-gray-500 font-medium text-sm"></td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg pr-64">
                  Cloud storage: Export docs and store in cloud
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="table-cell py-12 text-gray-500 text-lg  pr-64">PDF exports</td>
                <td className="table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr id="security" className="table-row">
                <td className="border-b w-256 pr-24 table-cell align-top pt-48 pb-12 text-blue-800 font-medium">
                  Security and support
                </td>
                <td className="border-b table-cell pt-48 pb-12 text-gray-500 font-medium text-sm"></td>
                <td className="border-b table-cell pt-48 pb-12 text-gray-500 font-medium text-sm"></td>
                <td className="border-b table-cell pt-48 pb-12 text-gray-500 font-medium text-sm"></td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg pr-64">
                  Set varying access control levels
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg  pr-64">
                  PDF exports
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg"> </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg  pr-64">
                  Accessibility
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="border-b table-cell py-12 text-gray-500 text-lg  pr-64">
                  Email support
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="border-b table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="table-cell py-12 text-gray-500 text-lg  pr-64">Bug reporting</td>
                <td className="table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
                <td className="table-cell py-12 text-blue-800 text-lg">
                  <TickMarkIcon className="text-blue-800" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          style={{ backgroundColor: '#FBFBF8' }}
          className="shadow-lg tablet:mt-32 desktop:my-107 laptop:my-90 mobile:mt-28 desktop:mb-107 rounded-lg mx-auto flex desktop:w-864 desktop:h-284 overflow-visible desktop:flex-row laptop:flex-col tablet:flex-col mobile:flex-col"
        >
          <div className="pt-32 px-32">
            <p className="text-gray-600 text-lg mb-16">
              <span
                role="img"
                aria-label="category"
                className="text-primary-800 text-2xl font-bold mb-8 mobile:text-xl block "
              >
                Enterprise solution
              </span>
              More than a 100 employees? Contact sales for a custom enterprise solution, including
              priority Sketchnote support, invoicing assistance, and more.
            </p>
            <Link href={'https://sketchnote.co/forms/636cf35095845f348e2221c8'}>
              <a target="_blank" className="text-blue-500 text-sm font-medium desktop:mb-24">
                <span className="inline-block">Contact us</span>
                <RightArrowIcon className="text-sm text-blue-500 ml-10 pt-4" />
              </a>
            </Link>
          </div>
          <img
            src="https://res.cloudinary.com/samvibes/image/upload/landing/Pricing/pricing-enterprise-solution.png"
            alt="Frances love looking up Sketchnote's pricing on a laptop"
            className="desktop:-mt-64 mobile:mt-0 laptop:mt-0 mobile:mb-12 desktop:mb-0 mx-auto desktop:h-332 laptop:h-273 laptop:max-w-500 tablet:max-w-332 mobile:max-w-284"
          />
        </div>
      </ContainerFixedMargin>
      <FooterSecondary />
      <Footer />
    </div>
  );
};
